import http, { host } from "../services/httpService";
import jwt_decode from "jwt-decode";
import { includes } from "lodash";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
const cookies = new Cookies();
const frontEndHost = window.location.hostname;

export const login = async (credentials) => {
  const basic_auth_headers = {
    "Content-Type": "application/json",
    Authorization: "ARBAPI TXlXYXlVc2VyOmRlbW8=",
  };

  const response = await http.post(host + "Authenticate/", credentials, {
    headers: basic_auth_headers,
  });
  const decoded = jwt_decode(response.data.Result.Token);
  if (decoded["IsOTPRequired"] === "True") {
    return response.data.Result.Token;
  }
  if (
    includes(jwt_decode(response.data.Result.Token)["role"], "aryabhatta") ===
    true
  ) {
    localStorage.setItem("access_token", response.data.Result.Token);
    window.location = "/dashboard/overview";
  } else toast.error("You are not an authorised user");
};

export const verifyOTP = async (userID, OTP) => {
  return await http.post(
    host + "VerifyOTP",
    {
      UserId: userID,
      OTP: OTP,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "ARBAPI TXlXYXlVc2VyOmRlbW8=",
      },
    }
  );
};

export const Verifychangepasscode = async (emailId, changepasscode) => {
  try {
    const response = await http.post(
      host + "Verifychangepasscode",
      {
        emailId: emailId,
        changepasscode: changepasscode,
      }
    );
    return response;
  } catch (error) {
    
    throw error;
  }
};
export const ResendPasscode = async (emailId) => {
  try {
    const response = await http.post(
      host + "ResendPasscode",
      {
        emailId: emailId
      }
    );
    return response;
  } catch (error) {
    
    throw error;
  }
};
export const logout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("aryabhattaUserName");
  window.location.reload()
};

export const getUser = () => {
  try {
    const user = jwt_decode(localStorage.getItem("access_token"));
    return user;
  } catch (error) {
    logout();
  }
};

export const getToken = () => {
  return localStorage.getItem("access_token");
};

http.setTokenInHeader(getToken());

export const updateUserProfile = async (formData) => {
  await http.put(
    host + "UpdateUserLogo",
    { data: formData },
    {
      headers: {
        "content-type": `multipart/form-data; boundary=${formData._boundary}`,
      },
    }
  );
};

export const authnew = (payload) => {
  return http.post(host + "AuthenticateNew", payload);
};
export const resendOTP = async ({ userId, appType = "Aryabhtta" }) => {
  
  return await http.post(host + "ResendOTP", {
    userId,
    appType
  });
};

export const ssoLogin = (payload) => {
  return http.post(host + "sso-login", payload);
};



